import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {mergeCandidate} from '/redux/action/candidate.action';
import {
  clientDetailsById,
  hasProfileById,
  urlDetailsById,
} from '/redux/selector/candidate.selector';
import {allReportData} from '/redux/selector/report.selector';
import {fromProps, withProps} from '/util/selector.util';

import {SecondMergeScreen} from './SecondMergeScreen';

const withCandidateId = withProps({
  candidateId: fromProps(get('recordId')),
});

export default connect(
  createStructuredSelector({
    allReportData,
    hasProfile: withCandidateId(hasProfileById),
    urlDetails: urlDetailsById,
    clientDetails: withCandidateId(clientDetailsById),
  }),

  dispatch => ({
    mergeCandidate: ({candidateId, body, allReportData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(mergeCandidate({candidateId, body, allReportData})),
  }),

  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    mergeCandidate: (candidateId: any, body: any) => {
      const {allReportData} = stateProps;
      return dispatchProps.mergeCandidate({
        candidateId,
        body,
        allReportData,
      });
    },
  }),
)(SecondMergeScreen);
